export { BookingIntegrated } from './BookingIntegrated';
